module.exports = {
  title: 'Red Thread Ventures',
  gtag: 'UA-172464553-1',
  url: '',
}
